import type { IconProps } from './types'
import styles from './style'

const StopIcon = ({ size = 24, color = '#e3e3e3' }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height={size + 'px'}
    viewBox='0 -960 960 960'
    width={size + 'px'}
    fill={color}
    style={styles.icon}
  >
    <path d='M320-320h320v-320H320v320Z' />
  </svg>
)

export default StopIcon
